import * as tslib_1 from "tslib";
import { TermsAndConditionsService } from '../../services/terms-and-conditions/terms-and-conditions.service';
import { ConsentScopesService } from '../../services/config/consent-scopes.service';
var TermsAndConditionsComponent = /** @class */ (function () {
    function TermsAndConditionsComponent(termsAndConditionsService, consentScopesService) {
        this.termsAndConditionsService = termsAndConditionsService;
        this.consentScopesService = consentScopesService;
        this.consentScopes = this.consentScopesService.getConsentScopes();
    }
    Object.defineProperty(TermsAndConditionsComponent.prototype, "agreeEnabled", {
        get: function () {
            return this._canAccept;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TermsAndConditionsComponent.prototype, "canAgree", {
        get: function () {
            return this.termsAndConditionsService.canAgreeToTermsAndConditions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TermsAndConditionsComponent.prototype, "hasAgreed", {
        get: function () {
            return this.termsAndConditionsService.hasAgreedToTermsAndConditions;
        },
        enumerable: true,
        configurable: true
    });
    TermsAndConditionsComponent.prototype.agree = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.termsAndConditionsService.agree()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TermsAndConditionsComponent.prototype.onScroll = function (event) {
        var target = event.target;
        this._canAccept = target.scrollHeight - Math.floor(target.scrollTop) === target.clientHeight;
        console.log(this._canAccept);
    };
    return TermsAndConditionsComponent;
}());
export { TermsAndConditionsComponent };
